import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'

import EvaluationGame from './EvaluationGame'

import { _route } from '../../routes/config'

import './styles.scss'

export enum InstructionPages {
  EvaluationGame = 1,
  AdditionInformation = -1
}

interface INativeProps {}

interface IProps extends INativeProps, RouteComponentProps {
  currentPatient: any
}

interface IState {
  current: InstructionPages
}

class Instructions extends React.Component<IProps, IState> {
  start = InstructionPages.EvaluationGame
  last = InstructionPages.EvaluationGame
  total: number = this.last
  justCreated: boolean = false

  private theme: Element | null = null
  private prevColor: string = ''

  constructor(props: IProps) {
    super(props)

    const {
      history: {
        location: { state }
      }
    } = this.props
    this.state = {
      // current: (state && (state.startTab as InstructionPages)) || this.start,
      current: InstructionPages.EvaluationGame
    }
    this.justCreated = state && history.state.justCreated
  }

  componentDidMount() {
    this.theme = document.querySelector('meta[name="theme-color"]')
    if (!this.theme) {
      this.theme = document.createElement('meta')
      document.head.appendChild(this.theme)
    }

    this.prevColor = this.theme.getAttribute('content') || ''
    this.theme.setAttribute('content', '#1a242e')
  }

  componentWillUnmount() {
    this.theme?.setAttribute('content', this.prevColor)
  }

  goBackAction = (isBrowserBack: boolean = false) => {
    const { history, currentPatient } = this.props
    const { current } = this.state
    if (this.start < current) {
      this.setState({ current: current - 1 })
      window.scrollTo(0, 0)
    } else if (this.justCreated) {
      history.replace(_route.child.add, {
        page: 'added'
      })
    } else if (!isBrowserBack) {
      history.replace(_route.games(currentPatient.patientId))
    }
  }

  disableBackButton = () => false

  commonProps = () => ({
    goBackAction: this.goBackAction,
    disableBackButton: this.disableBackButton()
  })

  next = () => {
    const { history, currentPatient } = this.props
    const { current } = this.state
    if (current < this.last) {
      this.setState({ current: current + 1 })
      window.scrollTo(0, 0)
    } else {
      history.replace(_route.games(currentPatient.patientId))
    }
  }

  renderContent = () => {
    const { history } = this.props
    const { current } = this.state
    switch (current) {
      case InstructionPages.EvaluationGame:
        return <EvaluationGame {...this.commonProps()} onSubmit={this.next} />
      default:
        history.replace(_route.child.list)
        return null
    }
  }

  render() {
    return this.renderContent()
  }
}

const WithRouter = withRouter(Instructions)

const mapStateToProps = state => {
  return {
    currentPatient: state.patients.currentPatient
  }
}

export default connect(mapStateToProps, null)(WithRouter)



// WEBPACK FOOTER //
// ./src/pages/Instructions/index.tsx